import React from 'react';
import { Text, StyleSheet, TouchableOpacity, View } from 'react-native';
import { DotIcon } from '../../resources/svgComponents/DotIcon';

export type TDotPosition = 'top' | 'right' | 'bottom' | 'left';

type TProgressButtonProps = {
  icon?: any;
  title: string;
  onPress?: () => void;
  dotPosition?: TDotPosition;
  dotColor?: string;
  colorText?: string;
  backgroundColor?: string;
  height?: number;
  dotSize?: number;
  fontSize?: number;
};

export const ProgressButton: React.FC<TProgressButtonProps> = ({
  icon,
  title,
  onPress,
  dotPosition = 'bottom',
  dotColor = '#FDDB96',
  colorText = '#121212',
  backgroundColor = '#FEF3D6',
  dotSize = 29,
  height = 51,
  fontSize = 16,
}) => {
  return (
    <TouchableOpacity
      style={[styles.container, { backgroundColor, height }]}
      onPress={onPress}
      activeOpacity={0.8}
    >
      {icon}
      <Text style={[styles.title, { color: colorText, fontSize }]}>{title}</Text>

      <View style={[styles.dotWrapper, getDotPosition(dotPosition)]}>
        <DotIcon color={dotColor} width={dotSize} height={dotSize} />
      </View>
    </TouchableOpacity>
  );
};

const getDotPosition = (position: TDotPosition) => {
  switch (position) {
    case 'top':
      return { left: '40%', top: -13 };
    case 'bottom':
      return { left: '40%', bottom: -13 };
    case 'left':
      return { left: -15, top: '20%' };
    case 'right':
      return { right: -15, top: '20%' };

    default:
      return {};
  }
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 8,
    paddingHorizontal: 12, // spacing for text & icon
    paddingVertical: 6,
    borderWidth: 1,
    borderColor: '#FDDB96',
    alignSelf: 'flex-start', // fit width to content
  },

  iconContainer: {
    width: 28,
    height: 28,
    backgroundColor: '#FFEDCC',
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
  },
  icon: {
    width: 18,
    height: 18,
  },
  title: {
    fontWeight: '400', // '400' is normal weight
  },
  dotWrapper: {
    position: 'absolute',
  },
});
